import LinkToDocusaurus from '../LinkToDocusaurus'
import { steps } from '../../docs-routes'

const LinkToTestResultsSteps = () =>
  <LinkToDocusaurus path={steps}>
    Learn more in the DAI documentation
  </LinkToDocusaurus>

export default LinkToTestResultsSteps
